import { useRef } from 'react';

/** Retain an intent after a lost response; clear it only after confirmed success or a new form session. */
export function useWorkIntent() {
  const intents = useRef(new Map<string, { signature: string; key: string }>());
  return {
    key(operation: string, payload: unknown) {
      const signature = JSON.stringify(payload);
      const prior = intents.current.get(operation);
      if (prior?.signature === signature) return prior.key;
      const key = crypto.randomUUID();
      intents.current.set(operation, { signature, key });
      return key;
    },
    complete(operation: string) {
      intents.current.delete(operation);
    },
    reset() {
      intents.current.clear();
    },
  };
}
